import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/55/thumb-landscape.jpg"

const Post55 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CELINE／チェーンマイヨントリオンフミディアム／22 x 15 x 5cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            突然ですが、私たちの心を捉えて離さないブランド、その筆頭に「CELINE（セリーヌ）」を挙げる方は多いのではないでしょうか？エレガントでありながら、どこかモードで洗練された雰囲気。いつの時代も色褪せない輝きを放ちながら、常に旬のムードを巧みに取り入れる。そのバランス感覚こそが、私たちの心を掴んで離さないのかもしれません。<br></br><br></br>
            そして、今、ファッションラバーたちの間でひときわ注目を集めているのが、セリーヌの<span className="text-font-bolder" style={{display: "inline", fontSize: "1.6rem"}}>「キャンバスバッグ」</span>なんです。気温の上昇とともに注目度が増す、ナチュラルな質感が魅力のキャンバス素材は、軽やかでカジュアルながら、上品さを失わないセリーヌの真髄を体現しています。<br></br><br></br>
            セリーヌのキャンバスバッグと聞いて、まずアイコニックな「トリオンフキャンバス」を思い浮かべる方も多いでしょう。しかし、今回は、コーティング加工を施していない、夏らしい涼しげな素材感を活かしたキャンバスバッグを中心にご紹介します。<br></br><br></br>
            「キャンバスってカジュアルになりすぎない？」<br></br>
            「セリーヌらしさはちゃんとあるの？」<br></br><br></br>
            そんな風に思っている方にこそ、ぜひ知っていただきたいセリーヌのキャンバスバッグの世界。レザーとはまた違う、軽やかで、でも品格を失わない、絶妙な魅力が詰まっているんです。<br></br>
            今回は、そんなセリーヌのキャンバスバッグの魅力に迫りつつ、ラクサスでも人気のある<span className="text-font-bolder" style={{display: "inline", fontSize: "1.6rem"}}>「人気ランキングTOP6」</span>を発表します！あなたの次の「借りたい・欲しい！」リストに、きっとセリーヌのキャンバスバッグが加わるはずです。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">            
      <div id ="sec1" className="text-max-width">
        <h1>なぜ今、セリーヌのキャンバスバッグが気分なの？</h1>
      </div>
      <p className="text-max-width">街を歩けば、ちらほらと目にするナチュラルカラーのキャンバスバッグ。数あるブランドの中でも、セリーヌのキャンバスバッグはひと味違います。ただ「カジュアル」なだけではなく、どこか凛としたムードを漂わせるのが最大の魅力。</p>
      <p className="text-max-width">
        では、なぜ今、こんなにも私たちの心を惹きつけるのでしょうか？<br></br>
        その理由を、3つのキーワードに沿って紐解いてみましょう。
      </p>
      <div className="border"></div> 
      <h2>1. 「軽さ」と「品格」の絶妙なバランス</h2>
      <p className="text-max-width">キャンバス生地の最大の魅力といえば、まずその軽さ。レザーのバッグが持つ重厚感も素敵だけれど、夏の気分には少しだけ“軽やかさ”が欲しくなるもの。セリーヌのキャンバスバッグは、そんな軽さを味わいながらも、決してラフすぎない。シンプルなロゴの配置や、レザーのトリミングがほどよく効いていて、カジュアルさの中に漂う上品さを演出してくれます。重さを感じさせないのに、きちんと存在感を放つ、この相反する要素のバランスこそが、多くのファンを魅了する秘密です。</p>
      <div className="border"></div> 
      <h2>2. 日常に馴染みながら、きちんと「今っぽい」</h2>
      <p className="text-max-width">
        どんなに素敵なバッグでも、ライフスタイルに馴染まなければ意味がない。<br></br>
        セリーヌのキャンバスバッグは、荷物をサッと入れられるトート型や、肩掛けで両手が空くショルダー型など、実用性の高さも人気の理由。無駄を削ぎ落としたミニマルなデザインだからこそ、日常着にも馴染み、肩肘張らずに「今っぽさ」をプラスしてくれるのです。トレンドを押さえつつも、流行に左右されない普遍性も兼ね備えています。
      </p>
      <div className="border"></div> 
      <h2>3. 自然体だけど、ちゃんと目を惹く存在感</h2>
      <p className="text-max-width">例えば、カフェのテラス席で、セリーヌのキャンバスバッグを無造作にテーブルに置いている女性を見かけたとき、なんてことのないシーンなのになぜかとびきりおしゃれに見えます。持つ人の個性を引き立てながら、全体の印象をワンランクアップさせる、まさに理想のアイテムと言えるでしょう。</p>
      <div className="border"></div> 
      <div id ="sec2" className="text-max-width">
        <h1>セリーヌのキャンバスバッグ人気ランキングTOP6</h1>
      </div>
      <p className="text-max-width space-bottom">ここからは、数あるセリーヌのキャンバスバッグの中から、特に人気が高く、注目を集めているモデルをランキング形式でご紹介します。それぞれのバッグの魅力や、おすすめのスタイリングも合わせてチェックしてくださいね。</p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/1.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/2.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／TRIOMPHE スモールカバタイス／25 x 19 x13cm</span>  
      <h2 className="text-font-bolder text-color-gray">第6位：シンプルさが魅力！TRIOMPHE スモールカバタイス</h2>
      <p className="text-max-width">セリーヌのトートバッグの定番中の定番。ナチュラルカラーキャンバスにストライプ柄、そしてセリーヌのロゴがシンプルにあしらわれたデザインです。「スモール」と名付けられている通り、普段使いしやすいコンパクトなサイズ感。これからの季節にぴったりな夏でも重く見えない抜け感のあるスタイルになります。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        「カジュアルすぎないキャンバスバッグが欲しい」<br></br>
        「夏でも重く見えない、抜け感のあるトートを探している」<br></br>
        セリーヌのバッグの中では比較的カジュアルですが、素材やシルエットの上品さで大人の余裕を演出。 肩肘張らないのにきちんと感も漂うそんな絶妙なバランスが人気の理由です。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        ブラックのノースリーブワンピースが主役。<br></br>
        爽やかな白のカーディガンを羽織って程よいきちんと感を。<br></br>
        ベージュのサンダルとキャスケットが夏らしいリラックスムードを漂わせます。<br></br>
        そこにスモールカバタイスを合わせれば、ナチュラルなキャンバスとブラウンレザーのアクセントが、シックなモノトーンコーデに柔らかさと季節感をプラスしてくれます。<br></br>
        ゴールドのリングでさりげなく華やかさを添えるのもポイントで、全体的にバランスの取れた、都会的なサマースタイルが完成します。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/3.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/4.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／TRIOMPHE ミニアヴァ／16 x 12 x 4cm</span>  
      <h2 className="text-font-bolder text-color-gray">第5位：ハーフムーン型「TRIOMPHE ミニアヴァ」</h2>
      <p className="text-max-width">ころんとした小ぶりのサイズ感ながら、必要最低限のものがきちんと収まり、身軽なお出かけにぴったり。コンパクトでありながら、確かな存在感を放ちます。カジュアルからきれいめまで幅広いスタイルにすっと馴染みます。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        「スマホとお財布だけで、軽やかにお出かけしたい」<br></br>
        「アクセ感覚で持てるコンパクトなバッグが欲しい」<br></br>
        そんな声に応えてくれるのが、このミニアヴァです。<br></br>
        ちょっとしたお買い物から、友人とのランチまで、幅広いシーンで活躍する万能さも魅力で、どんなコーデも一気に旬顔にしてくれます。そんなところがファッションラバーの心を掴んで離しません。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        ホワイトを基調としたワントーンコーディネート。<br></br>
        イエローのキャップが軽やかなアクセントを添えています。<br></br>
        足元にはスポーツサンダルを合わせ、今どきのスポーティーさを演出。<br></br>
        全体的にカジュアルな雰囲気ながらも、ミニアヴァをプラスすることで大人の抜け感スタイルに仕上がります。休日のアクティブなシーンにもぴったりのカジュアルルックです。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/5.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/6.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／TRIOMPHE オーバルパース／16 x 12 x 4cm</span>  
      <h2 className="text-font-bolder text-color-gray">第4位：オーバル形が可愛い「TRIOMPHE オーバルパース」</h2>
      <p className="text-max-width">ユニークな横長のオーバル（楕円）形が特徴の「TRIOMPHE オーバルパース」。SNSでもよく見かける人気のバッグです。かっちりしすぎず、でもきちんと感もある、絶妙なバランスが魅力です。キャンバスにレザーのトリミングが施されており、上品な印象です。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        個性的な横長のオーバルフォルムがおしゃれ感度が高い人々に支持されています。セリーヌらしさをしっかりアピールしつつ、キャンバス素材なので気負いなく持てるのが魅力。「ありそうでない」デザインが、コーディネートのアクセントになります。小ぶりながらも存在感があり、シンプルながらも個性を表現できる、まさに今の気分にぴったりのアイテムです。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        ホワイトのロングワンピースにフリルとカットワーク刺繍が映え、爽やかで女性らしい雰囲気を演出。<br></br>
        ブラックの麦わら帽子とゴールドのパールイヤリングで上品さを。<br></br>
        キャンバス地のオーバルバッグが程よい抜け感をプラスします。<br></br>
        ヌーディーカラーのサンダルで足元を軽やかにまとめ、リゾート感とクラシックさを両立させた夏のお出かけにぴったりのコーディネートが完成。休日のランチや旅行先での散策など、幅広いシーンで活躍してくれるでしょう。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/7.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/8.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／TRIOMPHE ティーンドローストリング／14 x 20 x 14cm</span>  
      <h2 className="text-font-bolder text-color-gray">第3位：巾着形「TRIOMPHE ティーンドローストリング」</h2>
      <p className="text-max-width">カジュアルさと上品さを兼ね備えたセリーヌの「TRIOMPHE ティーンドローストリング」。ブランドのアイコニックなトリオンフ柄キャンバスに、レザーの大きなトリオンフロゴが存在感を放つ巾着形バッグです。柔らかいシルエットと、程よい収納力と軽さも魅力。カジュアルコーデにも上質さを添えてくれる万能アイテムです。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        トリオンフのモノグラムとレザーのコンビネーションが、トレンドに流されないクラシックさを演出。巾着形の程よいラフさが抜け感を生み、普段使いからリゾートスタイルまで幅広く対応します。コンパクトながら目を引く存在感で、コーデの主役にもアクセントにもなるのが人気の理由です。肩掛けや斜め掛けで気軽に持ち歩ける手軽さも、忙しい現代女性のライフスタイルにマッチしています。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        ロゴTシャツにデニムスカートを合わせたカジュアルスタイル。<br></br>
        キャップとメガネをプラスして知的でラフな雰囲気に。<br></br>
        足元はスポーティーなサンダルで軽快さを出し、ティーンドローストリングを肩掛けすれば、大人のこなれ感漂うお出かけスタイルになります。バッグの上品さが、カジュアルな装いをクラスアップさせ、ラフな中にも洗練された印象を与えてくれます。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/9.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/10.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／TRIOMPHE マイヨントリオンフミディアム／22 x 15 x 5cm</span>  
      <h2 className="text-font-bolder text-color-gray">第2位：オンオフ問わず活躍！「TRIOMPHE マイヨントリオンフミディアム」</h2>
      <p className="text-max-width">「TRIOMPHE マイヨントリオンフミディアム」は、パリの凱旋門を取り囲む鎖から着想を得た「トリオンフ」のモチーフが、ゴールドカラーの金具としてバッグのフロントに大きくあしらわれているのが特徴です。丸みをおびたフォルムは上品さと女性らしさを演出し、オンオフ問わず活躍する逸品です。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        スマホ、長財布、ハンカチ、最低限のメイク小物など、大人の外出に必要なものがきちんと収まるのも嬉しいポイント。大きすぎず、小さすぎない「ちょうど良さ」が、大人世代に支持され、「一つは持っておきたい」と言われる定番バッグです。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        鮮やかなグリーンのニットにホワイトパンツを合わせ、清潔感と華やかさを両立したスタイルに。<br></br>
        エレガントな腕時計と繊細なネックレスで女性らしいきちんと感をプラス。<br></br>
        足元は抜け感のあるミュールで軽やかに。<br></br>
        仕上げにマイヨントリオンフミディアムを肩にかければ、旬のエレガンススタイルの完成です。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/11.jpg"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/55/12.jpg"/>
        </figure>
      </div>
      <span className="text-center">CELINE／CABAS スモールバーティカルカバ／28 x 32 x 8cm</span>  
      <h2 className="text-font-bolder text-color-gray">第1位：セリーヌの顔！「CABAS スモールバーティカルカバ」</h2>
      <p className="text-max-width">セリーヌのキャンバスバッグの代表格とも言える「CABAS スモールバーティカルカバ」！ ミニサイズよりも少し大きく、デイリーに必要なものがしっかり収まる絶妙なサイズ感が、幅広い層から支持されています。セリーヌの歴史的なアイコンの一つ「馬車」のロゴが大きくプリントされたキャンバス素材は、ブランドの伝統とモダンな感性が見事に融合したアイテムです。この他にも、シンプルな「CELINE」ロゴのみをさりげなく配したデザインもあります。</p>
      <p className="text-max-width">
        <span className="text-border-bottom">なぜ人気？</span><br></br>
        サイズ感が最大の魅力。取り外し可能なショルダーストラップ付きで、ハンドバッグ、肩掛け、クロスボディと3WAYで使えます。セリーヌのキャンバスバッグといえば、まずこのモデルを思い浮かべる方も多いのではないでしょうか。 キャンバスバッグを一つ持つなら検討する価値ありです。
      </p>
      <p className="text-max-width space-bottom">
        <span className="text-border-bottom">コーディネート例</span><br></br>
        クリーンなホワイトのボウタイブラウスに、柔らかなラベンダーカラーのマーメイドスカート。<br></br>
        足元はブラックのミュールパンプスで引き締め、知的な印象をプラス。<br></br>
        手元には華奢なゴールドのブレスレットと、スクエアフェイスの時計を。<br></br>
        このフェミニンな装いに、セリーヌの「CABAS スモールバーティカルカバ」を合わせることで、オフィスシーンから休日のブランチまで対応できる、洗練された大人のコーディネートが完成します。
      </p>
      <div id ="sec3" className="text-max-width">
        <h1>キャンバスバッグをもっとおしゃれに持つためのスタイリングヒント</h1>
      </div>
      <p className="text-max-width">ランキングでご紹介したバッグ以外にも、セリーヌには魅力的なキャンバスバッグがたくさんあります。ここでは、キャンバスバッグをさらに素敵に、自分らしく着こなすためのスタイリングのヒントをお届けします。</p>
      <p className="text-max-width">
        1. <span className="text-border-bottom">バッグのレザーカラーと全体の色調をリンクさせる</span><br></br>
        セリーヌのキャンバスバッグは、多くがレザーのトリミングやハンドルが施されています。このレザー部分の色を、靴やベルト、時計のベルトといった小物と合わせることで、コーディネート全体に統一感が生まれ、ぐっと品格がアップします。さらに、このバッグのレザーカラーを基点に、ワントーンコーデで洗練された印象にまとめたり、モノトーンコーデや落ち着いた色合いのスタイルに挿し色として加えることで、単調さを避け、洗練された大人のムードを演出できます。
      </p>
      <p className="text-max-width">
        2. <span className="text-border-bottom">アクセサリーで華やかさをプラス</span><br></br>
        シンプルなキャンバスバッグには、存在感のあるアクセサリーが映えます。ゴールドやシルバーのボリュームネックレス、大ぶりのピアス、時計やブレスレットなどをプラスして、顔周りや手元に華やかさを加えましょう。バッグのカジュアルさとアクセサリーの輝きが、おしゃれなコントラストを生み出します。
      </p>
      <p className="text-max-width">
        3. <span className="text-border-bottom">きれいめアイテムとのミックススタイルを楽しむ</span><br></br>
        同じキャンバス素材でも、バッグのサイズ感で印象は大きく変わります。ミニバッグはアクセサリー感覚で、コーディネートのポイントに。ミディアムサイズはデイリーユースに最適で、バランスを取りやすい万能選手。ビッグサイズは、コーディネートの主役になり、こなれ感を演出できます。その日の気分や荷物の量、そして全体のバランスを考えて、最適なサイズのバッグを選びましょう。
      </p> 
      <div id ="sec4" className="text-max-width">
        <h1>まとめ：セリーヌのキャンバスバッグで、もっと素敵な毎日を</h1>
      </div>
      <p className="text-max-width">
        いかがでしたか？<br></br><br></br>
        セリーヌのキャンバスバッグは、その選び抜かれた素材、考え抜かれたデザイン、そして使いやすさが一つになることで生まれる、特別な魅力が詰まっています。<br></br><br></br>
        キャンバスの誰もが知る存在感も、控えめなロゴデザインの持つ上品さも、どちらも私たちの毎日にすっと溶け込みながら、普段の着こなしをぐんとおしゃれに見せてくれる力があります。<br></br><br></br>
        今回ご紹介した人気ランキングを参考に、ぜひあなたにぴったりのセリーヌのキャンバスバッグを見つけてみてください。きっと、あなたの暮らしに新しい喜びと、わくわくする瞬間を届けてくれるはずです。<br></br><br></br>
        セリーヌのキャンバスバッグと共に、上質なカジュアルスタイルを思いっきり楽しんでくださいね！
      </p> 
      <div className="border"></div>        
      <p className="text-max-width">📱憧れを日常に──ラクサスでセリーヌを体験しよう！</p>                           
      <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
        セリーヌのバッグはこちら
      </Link>  
    </section>
    </div>
  </div>
</Layout>
)}

export default Post55

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 55}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`